<template>
  <div class="page modalita-d-uso">
    <CenteredContent :item="modalitaDuso" />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import { useHelpers } from '~/composables/helpers.js'
import queries from '@/graphql/craft/queries/index.js'

const { configuration } = useStore()
const route = useRoute()

// Fetch Data
const query = queries.modalitaDuso.getModalitaDuso

const variables = computed(() => ({
  site: configuration.site,
  slug: route.params.slug,
}))

const { data } = await useGraphql(query, variables)

if (!data.value.modalitaDusoEntries?.[0]) {
  throw createError({ statusCode: 404 })
}
const modalitaDuso = computed(() => data.value.modalitaDusoEntries?.[0])
const seo = computed(() => data.value?.modalitaDusoEntries?.[0]?.seo || {})

const localeParams = computed(
  () => data.value?.modalitaDusoEntries?.[0]?.localized || [],
)

// Seo
useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
